import { render, staticRenderFns } from "./importFacilitys.vue?vue&type=template&id=637ab8a2&scoped=true"
import script from "./importFacilitys.vue?vue&type=script&lang=js"
export * from "./importFacilitys.vue?vue&type=script&lang=js"
import style0 from "./importFacilitys.vue?vue&type=style&index=0&id=637ab8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ab8a2",
  null
  
)

export default component.exports